import React, { Component, PropTypes } from 'react'

import { getProperty, filterObject } from '../utils'
import { Loading } from '../misc'
import {
    Boolean,
    Button,
} from '../ui'
import ComputerSelectionFormOnly from './modals/computer_selection_form_only'

export default class ComputersSimple extends Component {
    static propTypes = {
        appState: PropTypes.shape({
            loading: PropTypes.bool.isRequired,
        }).isRequired,
        crewType: PropTypes.string.isRequired,
        crew_uuid: PropTypes.string.isRequired,
        data: PropTypes.object.isRequired,
        gear: PropTypes.object.isRequired,
        gearActions: PropTypes.object.isRequired,
        updateValue: PropTypes.func.isRequired,
    }

    _updateValueAndSendPatchRequest = (data) => {
        this.props.updateValue(data)
        this._sendPatchRequest(data)
    }

    _sendPatchRequest = (data = this.props.data) => {
        const newData = filterObject(
            data,
            [ 'own_laptop', 'own_desktop', 'laptop', 'desktop' ],
        )

        this.props.gearActions.patchGear(newData, this.props.crew_uuid, this.props.crewType)
    }

    _submitComputerData = (type) => () => {
        this.props.gearActions.postGear(
            {
                [type]: {
                    computer_type: type.toUpperCase(),
                    ...this.props.data[type],
                },
            },
            this.props.crew_uuid,
        )
    }

    render() {
        if (! this.props.data) {
            return <Loading />
        }

        const errors = this.props.gear.errors

        let laptopForm = null

        if (getProperty(this.props.data, 'own_laptop', false) === true) {
            const laptopSubFormProps = {
                prefix: 'laptop_',
                data: getProperty(this.props.data, 'laptop'),
                errors: errors.laptop || {},
                fields: [
                    'make', 'model', 'year',
                    'usb3', 'thunderbolt',
                    'additional_details',
                ],
                updateValue: (data) => {
                    // first get existing data
                    let newData = getProperty(this.props.data, 'laptop', {})

                    // if it was null or false, etc., let's make it an empty object
                    if (! newData) {
                        newData = {}
                    }

                    // now go through the provided data and remove the prefix before setting the value
                    for (const key in data) {
                        newData[key.slice('laptop_'.length)] = data[key]
                    }

                    this.props.updateValue({ laptop: newData })
                },
            }

            laptopForm = (
                <div>
                    <ComputerSelectionFormOnly { ...laptopSubFormProps } />
                    <Button
                        buttonOnly
                        loading={ this.props.appState.loading }
                        onClick={ this._submitComputerData('laptop') }
                        status="primary"
                    >
                        Save
                    </Button>
                </div>
            )
        }

        let desktopForm = null

        if (getProperty(this.props.data, 'own_desktop', false) === true) {
            const desktopSubFormProps = {
                prefix: 'desktop_',
                data: getProperty(this.props.data, 'desktop'),
                errors: errors.desktop || {},
                fields: [
                    'make', 'model', 'year',
                    'usb3', 'thunderbolt',
                    'additional_details',
                ],
                updateValue: (data) => {
                    // first get existing data
                    let newData = getProperty(this.props.data, 'desktop', {})

                    // if it was null or false, etc., let's make it an empty object
                    if (! newData) {
                        newData = {}
                    }

                    // now go through the provided data and remove the prefix before setting the value
                    for (const key in data) {
                        newData[key.slice('desktop_'.length)] = data[key]
                    }

                    this.props.updateValue({ desktop: newData })
                },
            }

            desktopForm = (
                <div>
                    <ComputerSelectionFormOnly { ...desktopSubFormProps } />
                    <Button
                        buttonOnly
                        loading={ this.props.appState.loading }
                        onClick={ this._submitComputerData('desktop') }
                        status="primary"
                    >
                        Save
                    </Button>
                </div>
            )
        }

        return (
            <div className="content__inner">
                <div className="box">
                    <div className="box__header">
                        <div className="box__title">
                            Computers
                        </div>
                    </div>
                    <div className="box__content box__content--padded">
                        <Boolean
                            error={ errors.own_laptop }
                            label="Do you own a laptop?"
                            name="own_laptop"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'own_laptop') }
                        />
                        { laptopForm }

                        <hr />

                        <Boolean
                            error={ errors.own_desktop }
                            label="Do you own a desktop?"
                            name="own_desktop"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'own_desktop') }
                        />
                        { desktopForm }
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/gear/computers_simple.js